import { Directive, ElementRef, Input, Renderer2, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[appDisableInteraction]'
})
export class DisableInteractionDirective implements OnChanges, AfterViewInit {
    @Input() public appDisableInteraction: boolean = false;
    private observer: MutationObserver;

    public constructor(private el: ElementRef, private renderer: Renderer2) {
        this.observer = new MutationObserver(() => {
            this.applyDisableState();
        });
    }

    public ngAfterViewInit() {
        setTimeout(() => {
            this.applyDisableState();
            this.startObserving();
        });
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes['appDisableInteraction']) {
            this.applyDisableState();
        }
    }

    private applyDisableState() {
        const elements = this.el.nativeElement.querySelectorAll('button, input, textarea, select, a, [tabindex]');
        elements.forEach((element: HTMLElement) => {
            if (element.className.includes('ignore-disable'))
                return;
            if (this.appDisableInteraction) {
                this.renderer.setAttribute(element, 'tabindex', '-1');
                this.renderer.setAttribute(element, 'disabled', 'true');
            } else {
                this.renderer.removeAttribute(element, 'tabindex');
                this.renderer.removeAttribute(element, 'disabled');
            }
        });

        const datepickerToggleButtons = this.el.nativeElement.querySelectorAll('mat-datepicker-toggle button');
        datepickerToggleButtons.forEach((toggleButton: HTMLElement) => {
            this.renderer.setAttribute(toggleButton, 'tabindex', '-1');
            this.renderer.removeAttribute(toggleButton, 'disabled');
        });
    }

    private startObserving() {
        this.observer.observe(this.el.nativeElement, {
            childList: true,
            subtree: true
        });
    }
}
